import {asign_data} from './datadb/index.js';
import {deepCopy} from './functions/functions.js';
import router from '@/services/router.js';

import idb from '@/api/datadb';

// Constants 
const dataForm = () => 
{
        return asign_data().dataForm
}
const dataPost = () => {
        var dataPost=asign_data().dataPost 
        return  dataPost

}
const dataGet = () => {
        var dataGet=asign_data().dataGet 
        return dataGet
}
const tableSave = () => { 

        return {}
}
const dataMultiple = () => 
{
        return { }
}
  
// RESET CONST
  function reset()
  {
    var returnReset = {     
        dataMultiple     :  dataMultiple(), 
        dataForm         :  dataForm(),   
        dataPost         :  dataPost(),   
        dataGet          :  dataGet(),     
        tableSave        :  tableSave(),           
        namePath         :  'aflprueba',
        basico           :  false,
        consecutivo      :  0,
        renderForce      :  0,
        swSearchs        :  { },
        searchSw         :  { value: ''},
    }      
    return returnReset
  }



// State
export const state = {
        consecutivo:      reset()['consecutivo'],
        searchSw:         reset()['searchSw'],
        swSearchs:        reset()['swSearchs'],
        tableSave:        reset()['tableSave'],
        dataForm:         reset()['dataForm'],
        dataPost:         reset()['dataPost'],
        dataGet:          reset()['dataGet'],
        dataMultiple:     reset()['dataMultiple'],
        namePath:         reset()['namePath'],
        renderForce:      reset()['renderForce'],
        basico:           reset()['basico'],
        mostrarResultado: false,
        listsDatadb:  [],
        lists: {                 
                list_tipo: [],  
                list_genero: [],                 
                list_eps: [],                  
                list_users: [],               
                datos_pacientes: [],               
                datos_proveedores_lente: [],               
                datos_proveedores_montura: [], 
        },
};
// Getters
export const getters = {        
        gettersDatalist: (state,getters) => (list,id) => {  
                if( state.lists[list].filter( list => { 
                        return ( list.id.toString()=== id.toString() && id!='' ) || ( list.name.toString()=== id.toString() && id!='' ) } ))
                {
                        return state.lists[list].filter( list => {return list.id.toString()=== id.toString() || list.name.toString()=== id.toString() }) 
                }
                 return ''                        
        },

};
// Actions
export const actions = {
// localstorate
        async getIdb(context) {
                let listsKeys= Object.keys(context.state.lists)
                for (let i = 0; i < listsKeys.length; i++) { 
                        let listsDatadb = await idb.getIdb(listsKeys[i]);                        
                        listsDatadb.forEach(c => {
                                if( context.state.lists[listsKeys[i]].find( list => list.id === c.id ) === undefined )
                                {
                                        context.state.lists[listsKeys[i]].push(c);
                                }                                
                        });                        
                }                        
        },
        async saveIdb(context, data){                
                let listsKeys= Object.keys(data)                
                for (let i = 0; i < listsKeys.length; i++) { 
                        await idb.saveIdb({data: data[listsKeys[i]], list: listsKeys[i]})
                        let listsDatadb = await idb.getIdb(listsKeys[i])                       
                        listsDatadb.forEach(c => {
                                if( context.state.lists[listsKeys[i]].find( list => list.id === c.id ) === undefined )
                                {
                                        context.state.lists[listsKeys[i]].push(c)
                                }                                
                        });                        
                }                 
        },
// ACTIONS DATAMULTIPLE
        updateDataMultiple({commit},data){
                return new Promise((resolve ) => {
                        commit('updateDataMultiple', { data: data ,callback: resolve})        
                }) 
        },
//ACTION SAVE BACKEND
        saveAll({commit,state}, config)
        {	
                return new Promise((resolve,reject ) => {
                        axios
                                .post(config.route, { data: config.data, name_path: state.namePath, auditar: config.tablaAuditar})
                                .then(response => {
                                        resolve(response)}
                                        , error => { 
                                        console.log(error)
                                        reject(error)})
                })
        },
        getDataGet({commit,state}, config)
        {	
                return new Promise((resolve,reject ) => {
                        axios
                                .get(config.route, { params: { data: config.data}})
                                .then(response => {
                                                commit('updateCrud', { data: {data: response.data.consecutivo, state: 'consecutivo'} ,callback: resolve})
                                                commit('updateDataGet', { data: response.data ,callback: resolve})  
                                                resolve(response)
                                        }
                                        , error => { 
                                                console.log(error)
                                                reject(error)
                                        }
                                )
                })
        },
        getDataList({commit,state}, config)
        {	
                return new Promise((resolve,reject ) => {
                        axios
                                .get(config.route, { data: config.data})
                                .then(async response => { 
                                        let listsKeys= Object.keys(response.data.data)  
                                        for (let i = 0; i < listsKeys.length; i++) { 
                                                await idb.saveIdb({data: response.data.data[listsKeys[i]], list: listsKeys[i]})
                                                let listsDatadb = await idb.getIdb(listsKeys[i]) 
                                                listsDatadb.forEach(c => {
                                                        if( state.lists[listsKeys[i]].find( list => list.id === c.id ) === undefined )
                                                        {
                                                                state.lists[listsKeys[i]].push(c)
                                                        }                                
                                                });                        
                                        } 
                                        resolve(true)
                                }
                                , error => { 
                                        window.localStorage.clear();
                                        commit('resetState');
                                        delete axios.defaults.headers.common["Authorization"];
                                        router.push('/auth/login');
                                        reject(error)
                                }
                        )
                })
        },
//ACTIONS DATAGET      
        resetDataGet({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('resetDataGet', { data: data ,callback: resolve})        
                })          
        },
        spliceDataGet({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('spliceDataGet', { data: data ,callback: resolve})        
                })          
        },
        updateDataGet({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('updateDataGet', { data: data ,callback: resolve})        
                })          
        },
        pushDataGet({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('pushDataGet', { data: data ,callback: resolve})        
                })          
        },
//ACTIONS DATAFORM        
        resetDataForm({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('resetDataForm', { data: data ,callback: resolve})        
                })          
        },
        spliceDataForm({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('spliceDataForm', { data: data ,callback: resolve})        
                })          
        },
        updateDataForm({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('updateDataForm', { data: data ,callback: resolve})        
                })          
        },
        changeDataForm({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('changeDataForm', { data: data ,callback: resolve})        
                })          
        },
        pushDataForm({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('pushDataForm', { data: data ,callback: resolve})        
                })          
        },
// ACTIONS DATAPOST
        resetDataPost({commit},data)
                {
                return new Promise((resolve ) => {
                        commit('resetDataPost', { data: data ,callback: resolve})        
                })          
        },
        spliceDataPost({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('spliceDataPost', { data: data ,callback: resolve})        
                })          
        },
        pushDataPost({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('pushDataPost', { data: data ,callback: resolve})        
                })          
        },
        updateDataPost({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('updateDataPost', { data: data ,callback: resolve})        
                })          
        },
        changeDataPost({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('changeDataPost', { data: data ,callback: resolve})        
                })          
        },
//ACTIONS OTHERS CRUD
        changeRender({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('changeRender', { data: '' ,callback: resolve})        
                })          
        },
        spliceCrud({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('spliceCrud', { data: data ,callback: resolve})        
                })          
        },
        pushCrud({commit},data)
        {
                return new Promise((resolve ) => {
                        commit('pushCrud', { data: data ,callback: resolve})        
                })          
        },
        resetCrud({commit},data)
        {
        return new Promise((resolve ) => {
                commit('resetCrud', { data: data ,callback: resolve})        
        })          
        },
        updateCrud({commit},data)
        {
                return new Promise((resolve) => {
                commit('updateCrud', { data: data ,callback: resolve})        
                }) 
        },
        changeCrud({commit},data)
        {
                return new Promise((resolve) => {
                commit('changeCrud', { data: data ,callback: resolve})        
                }) 
        }
};
// Mutations
export const mutations = {
  spliceDataForm(state,{data,callback}) 
  {
    try{
      var listState = data.state.split('/')
      var index= data.index

      if(data.search!=='' && data.search!==undefined)
      {
        var variable = ''

        switch(listState.length)
        {
          case 1:
                  variable = deepCopy(state.dataForm[state.namePath][listState[0]]) 
          break
          case 2:
                  variable = deepCopy(state.dataForm[state.namePath][listState[0]] [listState[1]] )
          break
          case 3:
                 variable = deepCopy( state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]])
          break
          case 4:
                 variable = deepCopy(state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] )
          break
          case 5:
                 variable = deepCopy(state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]]) 
          break
          case 6:
                 variable = deepCopy(state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]]) 
          break
          case 7:
                 variable = deepCopy(state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]])
          break
          case 8:
                 variable = deepCopy(state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] )
          break
          case 9:
                 variable = deepCopy(state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]]) 
          break
        } 

        for (var i = 0; i < variable.length; i++) 
        {
          if(variable[i][data.campo] == data.search)
          {
             index=i
             i=variable.length
          } 
        } 
      }

      switch(listState.length)
      {
        case 1:
                state.dataForm[state.namePath][listState[0]].splice(index,1)
                callback(true)
        break
        case 2:
                state.dataForm[state.namePath][listState[0]] [listState[1]].splice(index,1) 
                callback(true)
        break
        case 3:
               state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]].splice(index,1) 
                callback(true)
        break
        case 4:
               state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]].splice(index,1) 
                callback(true)
        break
        case 5:
               state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]].splice(index,1) 
                callback(true)
        break
        case 6:
               state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]].splice(index,1) 
                callback(true)
        break
        case 7:
               state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]].splice(index,1) 
                callback(true)
        break
        case 8:
               state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]].splice(index,1) 
                callback(true)
        break
        case 9:
               state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]].splice(index,1) 
                callback(true)
        break
      }  
    } catch (error) 
    {
        console.log('error in globalStore/mutation/splice,',error)
    }
  },
  changeDataForm(state,{data,callback})
  {
    try {
      var listState = data.state.split('/')    
      if(data.boolean==='')
      {      
        switch(listState.length) 
        {
          case 1: 
                  state[ listState[0] ] =! state[ listState[0] ]
                  callback(true)
          break
          case 2:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] =! state.dataForm[state.namePath][listState[0]] [listState[1]]
                  callback(true)
          break
          case 3:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] =! state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]]
                  callback(true)
          break
          case 4:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] =! state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]]
                  callback(true)
          break
          case 5:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] =! state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]]
                  callback(true)
          break
          case 6:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] =! state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]]
                  callback(true)
          break
          case 7:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] =! state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] 
                  callback(true)
          break
          case 8:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] =! state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] 
                  callback(true)
          break
          case 9:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] =! state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] 
                  callback(true)
          break
        }
      }
      else
      {
        switch(listState.length) 
        {
          case 1: 
                  state[ listState[0] ] = data.boolean
                  callback(true)
          break
          case 2:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] = data.boolean
                  callback(true)
          break
          case 3:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] = data.boolean
                  callback(true)
          break
          case 4:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] = data.boolean
                  callback(true)
          break
          case 5:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] = data.boolean
                  callback(true)
          break
          case 6:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = data.boolean
                  callback(true)
          break
          case 7:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = data.boolean
                  callback(true)
          break
          case 8:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = data.boolean
                  callback(true)
          break
          case 9:
                  state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = data.boolean
                  callback(true)
          break
        }
      } 
    } catch (error) 
    {
        console.log('error in globalStore/mutation/change,',error)
    }
  }, 
  updateDataForm(state,{data,callback})
  {
    try{
        
        if(data.state===undefined)
        {
                state.dataForm[state.namePath]= deepCopy(data.data)
                callback(true)   
        }
        else{
                var listState = data.state.split('/')
                switch(listState.length)
                {
                        case 1:
                                state.dataForm[state.namePath][listState[0]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 2:
                                state.dataForm[state.namePath][listState[0]] [listState[1]] = deepCopy(data.data)  
                                callback(true)            
                        break
                        case 3:              
                                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 4:
                                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 5:
                                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]]  [listState[4]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 6:
                                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 7:
                                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 8:
                                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 9:
                                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = deepCopy(data.data)
                                callback(true)
                        break
                }
        }
        
    } catch (error) 
    {
        console.log('error in globalStore/mutation/update,',error)
    }
  },
  resetDataForm(state,{data,callback})  
  {
    try{   
        if(data===undefined)  
        {
                state.dataForm[state.namePath] = reset().dataForm[state.namePath] 
                callback(true)   
        }
        else{
                var listState = data.state.split('/')        
                switch(listState.length)
                {
                case 1:
                        state.dataForm[state.namePath][listState[0]] = reset().dataForm[state.namePath] [listState[0]]
                        callback(true)
                break
                case 2:
                        state.dataForm[state.namePath][listState[0]] [listState[1]] = reset().dataForm[state.namePath] [listState[0]] [listState[1]]
                        callback(true)
                break
                case 3:
                        state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] = reset().dataForm[state.namePath] [listState[0]] [listState[1]] [listState[2]]
                        callback(true)
                break
                case 4:
                        state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] = reset().dataForm[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]]
                        callback(true)
                break
                case 5:
                        state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] = reset().dataForm[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]]
                        callback(true)
                break
                case 6:
                        state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = reset().dataForm[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]]
                        callback(true)
                break
                case 7:
                        state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = reset().dataForm[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] 
                        callback(true)
                break
                case 8:
                        state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = reset().dataForm[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] 
                        callback(true)
                break
                case 9:
                        state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = reset().dataForm[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] 
                        callback(true)
                break
                } 
        }
          
    }
    catch (error)
    {
        console.log('error in globalStore/mutation/reset,',error)
    }    
  },
  pushDataForm(state,{data,callback})   
  {
    try {
      var listState = data.state.split('/')
      switch(listState.length)
      {
        case 1:
                state.dataForm[state.namePath][listState[0]].push(deepCopy(data.data))
                callback(true)
        break
        case 2:              
                state.dataForm[state.namePath][listState[0]] [listState[1]].push(deepCopy(data.data))
                callback(true)
        break
        case 3:
                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]].push(deepCopy(data.data))
                callback(true)
        break
        case 4:
                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]].push(deepCopy(data.data))
                callback(true)
        break
        case 5:
                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]]  [listState[4]] = push(deepCopy(data.data))
                callback(true)
        break
        case 6:
                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = push(deepCopy(data.data))
                callback(true)
        break
        case 7:
                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = push(deepCopy(data.data))
                callback(true)
        break
        case 8:
                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = push(deepCopy(data.data))
                callback(true)
        break
        case 9:
                state.dataForm[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = push(deepCopy(data.data))
                callback(true)
        break
      } 
    } catch (error) 
    {
        console.log('error in globalStore/mutation/push,',error)
    }
  },
  spliceDataPost(state,{data,callback}) 
  {
    try{                       
                var index= data
                if(index!==undefined && typeof index === 'number')
                {
                  state.dataPost[state.namePath].data.splice(index,1) 
                  callback(true)                   
                }       
    } catch (error) 
    {
        console.log('error in globalStore/mutation/splice,',error)
    }
  },
  changeDataPost(state,{data,callback})    
  {
    try {
      var listState = data.state.split('/')    
      if(data.boolean==='')
      {      
        switch(listState.length) 
        {
          case 1: 
                  state[ listState[0] ] =! state[ listState[0] ]
                  callback(true)
          break
          case 2:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] =! state.dataPost[state.namePath][listState[0]] [listState[1]]
                  callback(true)
          break
          case 3:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] =! state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]]
                  callback(true)
          break
          case 4:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] =! state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]]
                  callback(true)
          break
          case 5:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] =! state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]]
                  callback(true)
          break
          case 6:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] =! state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]]
                  callback(true)
          break
          case 7:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] =! state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] 
                  callback(true)
          break
          case 8:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] =! state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] 
                  callback(true)
          break
          case 9:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] =! state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] 
                  callback(true)
          break
        }
      }
      else
      {
        switch(listState.length) 
        {
          case 1: 
                  state[ listState[0] ] = data.boolean
                  callback(true)
          break
          case 2:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] = data.boolean
                  callback(true)
          break
          case 3:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] = data.boolean
                  callback(true)
          break
          case 4:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] = data.boolean
                  callback(true)
          break
          case 5:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] = data.boolean
                  callback(true)
          break
          case 6:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = data.boolean
                  callback(true)
          break
          case 7:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = data.boolean
                  callback(true)
          break
          case 8:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = data.boolean
                  callback(true)
          break
          case 9:
                  state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = data.boolean
                  callback(true)
          break
        }
      } 
    } catch (error) 
    {
        console.log('error in globalStore/mutation/change,',error)
    }
  }, 
  updateDataPost(state,{data,callback})
  {
    try{
            
        if(data.state===undefined)
        {
                state.dataPost[state.namePath]= deepCopy(data.data)
                callback(true)   
        }
        else{
                var listState = data.state.split('/')
                switch(listState.length)
                {
                        case 1:
                                state.dataPost[state.namePath][listState[0]] = deepCopy(data.data)
                                state.renderForce++
                                callback(true)
                        break
                        case 2:
                                state.dataPost[state.namePath][listState[0]] [listState[1]] = deepCopy(data.data)                 
                                state.renderForce++
                                callback(true)            
                        break
                        case 3:              
                                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] = deepCopy(data.data)        
                                state.renderForce++
                                callback(true)
                        break
                        case 4:
                                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] = deepCopy(data.data)                
                                state.renderForce++
                                callback(true)
                        break
                        case 5:
                                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]]  [listState[4]] = deepCopy(data.data)                
                                state.renderForce++
                                callback(true)
                        break
                        case 6:
                                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = deepCopy(data.data)                  
                                state.renderForce++
                                callback(true)
                        break
                        case 7:
                                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = deepCopy(data.data)                  
                                state.renderForce++
                                callback(true)
                        break
                        case 8:
                                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = deepCopy(data.data)                  
                                state.renderForce++
                                callback(true)
                        break
                        case 9:
                                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = deepCopy(data.data)                  
                                state.renderForce++
                                callback(true)
                        break
                }
        }
    } catch (error) 
    {
        console.log('error in globalStore/mutation/update,',error)
    }
  },
  resetDataPost(state,{data,callback})  
  {
    try{   
        if(data===undefined)  
        {
                state.dataPost[state.namePath] = reset().dataPost[state.namePath] 
                callback(true)   
        }
        else{
                var listState = data.state.split('/')        
                switch(listState.length)
                {
                case 1:
                        state.dataPost[state.namePath][listState[0]] = reset().dataPost[state.namePath] [listState[0]]
                        callback(true)
                break
                case 2:
                        state.dataPost[state.namePath][listState[0]] [listState[1]] = reset().dataPost[state.namePath] [listState[0]] [listState[1]]
                        callback(true)
                break
                case 3:
                        state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] = reset().dataPost[state.namePath] [listState[0]] [listState[1]] [listState[2]]
                        callback(true)
                break
                case 4:
                        state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] = reset().dataPost[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]]
                        callback(true)
                break
                case 5:
                        state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] = reset().dataPost[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]]
                        callback(true)
                break
                case 6:
                        state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = reset().dataPost[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]]
                        callback(true)
                break
                case 7:
                        state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = reset().dataPost[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] 
                        callback(true)
                break
                case 8:
                        state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = reset().dataPost[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] 
                        callback(true)
                break
                case 9:
                        state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = reset().dataPost[state.namePath] [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] 
                        callback(true)
                break
                } 
        }
          
    }
    catch (error)
    {
        console.log('error in globalStore/mutation/reset,',error)
    }    
  },
  pushDataPost(state,{data,callback})   
  {
    try {
      var listState = data.state.split('/')
      switch(listState.length)
      {
        case 1:
                state.dataPost[state.namePath][listState[0]].push(deepCopy(data.data))
                state.renderForce++   
                callback(true)
        break
        case 2:              
                state.dataPost[state.namePath][listState[0]] [listState[1]].push(deepCopy(data.data))
                state.renderForce++ 
                callback(true)
        break
        case 3:
                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]].push(deepCopy(data.data))
                state.renderForce++ 
                callback(true)
        break
        case 4:
                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]].push(deepCopy(data.data))
                state.renderForce++ 
                callback(true)
        break
        case 5:
                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]]  [listState[4]] = push(deepCopy(data.data))
                state.renderForce++ 
                callback(true)
        break
        case 6:
                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = push(data.boolean)
                state.renderForce++ 
                callback(true)
        break
        case 7:
                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = push(data.boolean)
                state.renderForce++ 
                callback(true)
        break
        case 8:
                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = push(data.boolean)
                state.renderForce++ 
                callback(true)
        break
        case 9:
                state.dataPost[state.namePath][listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = push(data.boolean)
                state.renderForce++ 
                callback(true)
        break
      } 
    } catch (error) 
    {
        console.log('error in globalStore/mutation/push,',error)
    }
  },
  resetDataGet(state,{data,callback})  
  {
    try{   
                state.dataGet[state.namePath] = reset().dataGet[state.namePath] 
                callback(true)            
    }
    catch (error)
    {
        console.log('error in globalStore/mutation/reset,',error)
    }    
  },
  spliceDataGet(state,{data,callback}) 
  {
    try{                     
                var index= data
                if(index!==undefined && typeof index === 'number')
                {
                  state.dataGet[state.namePath].data.splice(index,1) 
                  callback(true)                   
                }       
    } catch (error) 
    {
        console.log('error in globalStore/mutation/splice,',error)
    }
  },
  updateDataGet(state,{data,callback})   
  {
    try {
            if(data.index!==undefined)
            {
                if(data.state!==undefined)
                {
                        state.dataGet[state.namePath].data[data.index][data.state]=deepCopy(data.data)
                }
                else{
                        state.dataGet[state.namePath].data[data.index]=deepCopy(data.data)
                }
                 
            } 
            else{
                state.dataGet[state.namePath].data=deepCopy(data.data) 
            }
            state.renderForce++   
            callback(true)   
    } catch (error) 
    {
        console.log('error in globalStore/mutation/updateDataGet,',error)
    }
  },
  pushDataGet(state,{data,callback})   
  {
    try {
            state.dataGet[state.namePath].data.push(data.data)  
            state.renderForce++   
            callback(true) 
    } catch (error) 
    {
        console.log('error in globalStore/mutation/pushDataGet,',error)
    }
  },
  pushCrud(state,{data,callback})   
  {
    try {
      var listState = data.state.split('/')
      switch(listState.length)
      {
        case 1:
                state[listState[0]].push(deepCopy(data.data))
                callback(true)
        break
        case 2:              
                state[listState[0]] [listState[1]].push(deepCopy(data.data))
                callback(true)
        break
        case 3:
                state[listState[0]] [listState[1]] [listState[2]].push(deepCopy(data.data))
                callback(true)
        break
        case 4:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]].push(deepCopy(data.data))
                callback(true)
        break
        case 5:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]]  [listState[4]] = push(deepCopy(data.data))
                callback(true)
        break
        case 6:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = push(deepCopy(data.data))
                callback(true)
        break
        case 7:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = push(deepCopy(data.data))
                callback(true)
        break
        case 8:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = push(deepCopy(data.data))
                callback(true)
        break
        case 9:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = push(deepCopy(data.data))
                callback(true)
        break
      } 
    } catch (error) 
    {
        console.log('error in globalStore/mutation/push,',error)
    }
  },
  updateCrud(state,{data,callback})
  {
        try{
          var listState = data.state.split('/')
          switch(listState.length)
          {
            case 1:
                    state[listState[0]] = deepCopy(data.data)
                    state.renderForce++
                    callback(true)
            break
            case 2:
                    state[listState[0]] [listState[1]] = deepCopy(data.data)  
                    state.renderForce++
                    callback(true)            
            break
            case 3:              
                    state[listState[0]] [listState[1]] [listState[2]] = deepCopy(data.data)
                    state.renderForce++
                    callback(true)
            break
            case 4:
                    state[listState[0]] [listState[1]] [listState[2]] [listState[3]] = deepCopy(data.data)
                    state.renderForce++
                    callback(true)
            break
            case 5:
                    state[listState[0]] [listState[1]] [listState[2]] [listState[3]]  [listState[4]] = deepCopy(data.data)
                    state.renderForce++
                    callback(true)
            break
              case 6:
                      state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = deepCopy(data.data)
                      state.renderForce++
                      callback(true)
              break
              case 7:
                      state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = deepCopy(data.data)
                      state.renderForce++
                      callback(true)
              break
              case 8:
                      state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = deepCopy(data.data)
                      state.renderForce++
                      callback(true)
              break
              case 9:
                      state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = deepCopy(data.data)
                      state.renderForce++
                      callback(true)
              break
          }
        } catch (error) 
        {
            console.log('error in globalStore/mutation/updateCrud,',error)
        }
  },
  changeCrud(state,{data,callback})     
  {
    try {
      var listState = data.state.split('/')  
      if(data.boolean==='')
      {      
        switch(listState.length) 
        {
          case 1: 
                  state[ listState[0] ] =! state[ listState[0] ]
                  state.renderForce++
                  callback(true)
          break
          case 2:
                  state[listState[0]] [listState[1]] =! state[listState[0]] [listState[1]]
                  state.renderForce++
                  callback(true)
          break
          case 3:
                  state[listState[0]] [listState[1]] [listState[2]] =! state[listState[0]] [listState[1]] [listState[2]]
                  state.renderForce++
                  callback(true)
          break
          case 4:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] =! state[listState[0]] [listState[1]] [listState[2]] [listState[3]]
                  state.renderForce++
                  callback(true)
          break
          case 5:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] =! state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]]
                  state.renderForce++
                  callback(true)
          break
          case 6:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] =! state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]]
                  state.renderForce++
                    state.renderForce++
                  callback(true)
          break
          case 7:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] =! state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] 
                    state.renderForce++
                  callback(true)
          break
          case 8:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] =! state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] 
                    state.renderForce++
                  callback(true)
          break
          case 9:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] =! state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]]
                    state.renderForce++ 
                  callback(true)
          break
        }
      }
      else
      {

        switch(listState.length) 
        {
          case 1: 
                  state[ listState[0] ] = data.boolean
                  callback(true)
          break
          case 2:
                  state[listState[0]] [listState[1]] = data.boolean
                  callback(true)
          break
          case 3:
                  state[listState[0]] [listState[1]] [listState[2]] = data.boolean
                  callback(true)
          break
          case 4:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] = data.boolean
                  callback(true)
          break
          case 5:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] = data.boolean
                  callback(true)
          break
          case 6:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = data.boolean
                  callback(true)
          break
          case 7:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = data.boolean
                  callback(true)
          break
          case 8:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = data.boolean
                  callback(true)
          break
          case 9:
                  state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = data.boolean
                  callback(true)
          break
        }
      } 
    } catch (error) 
    {
        console.log('error in globalStore/mutation/change,',error)
    }
  }, 
  resetCrud(state,{data,callback})  
  {
    try{  
        var listState = data.state.split('/')        
        switch(listState.length)
        {
        case 1:
                state[listState[0]] = reset() [listState[0]]
                callback(true)
        break
        case 2:
                state[listState[0]] [listState[1]] = reset() [listState[0]] [listState[1]]
                callback(true)
        break
        case 3:
                state[listState[0]] [listState[1]] [listState[2]] = reset() [listState[0]] [listState[1]] [listState[2]]
                callback(true)
        break
        case 4:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] = reset() [listState[0]] [listState[1]] [listState[2]] [listState[3]]
                callback(true)
        break
        case 5:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] = reset() [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]]
                callback(true)
        break
        case 6:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = reset() [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]]
                callback(true)
        break
        case 7:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = reset() [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] 
                callback(true)
        break
        case 8:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = reset() [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] 
                callback(true)
        break
        case 9:
                state[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = reset() [listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] 
                callback(true)
        break
        } 
          
    }
    catch (error)
    {
        console.log('error in globalStore/mutation/reset,',error)
    }    
  },
  updateDataMultiple(state,{data,callback}){
     try{
             var control = false
             for(var i=0;i<data.data.length; i++)
             {
                     
                  control = state.dataMultiple[data.state].findIndex( items => items.name_check===data.data[i].name_check) 
                  if(control>=0)
                  {
                          state.dataMultiple[data.state][control]=data.data[i]
                  }
             }
             callback(true)
     }catch {

     }
  },
}
